var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tab-wrapper"},[_c('vertical-tab',{attrs:{"tabs":_vm.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }